// extracted by mini-css-extract-plugin
module.exports = {"coloredBox":"SafetySteps_coloredBox__wMqjP"};